import React, { useState, useEffect } from 'react';
import { Alert, Link } from '@bw/foundry';

interface SignInFormAlertProps {
  errorCode: number | string;
}

const SignInFormAlert: React.FC<SignInFormAlertProps> = ({ errorCode }) => {
  const [alertText, setAlertText] = useState<string>(
    'Something unexpected happened, please try again.',
  );

  useEffect(() => {
    switch (errorCode) {
      case 429:
        setAlertText('Our server is busy, please try again shortly.');
        break;
      case 'none':
      case 401:
        setAlertText(
          'These login credentials are incorrect. If you continue guessing incorrectly, this may result in your account being locked for security purposes. Please wait 10 minutes and try again or try resetting your password.',
        );
        break;

      default:
        setAlertText('Something unexpected happened, please try again.');
        break;
    }
  }, [errorCode]);

  return (
    <Alert severity="error">
      {alertText} If you still can’t access your account, please{' '}
      <Link href="https://support.bandwidth.com/hc/en-us/requests/new">
        contact Bandwidth support
      </Link>
      .
    </Alert>
  );
};
export default SignInFormAlert;
